import { useNavigate } from '@rocketlane/rocket-router';
import { useCallback, useEffect } from 'react';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useLocalStorage } from 'hooks/use-local-storage';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { APP_SHELL_MODE_STORAGE_KEY, DEFAULT_APP_SHELL_MODE } from 'utils/app-shell-mode';
import { isTauriApp } from 'utils/is-tauri';
/**
 * Persisted Rocketlane ↔ Nitro Claw shell preference (web).
 * Tauri presents the Nitro Claw shell when `AccountFeature.NitroClaw` is on.
 * When the account feature is off, web preference is reset to Rocketlane.
 */ export const useAppShellMode = ()=>{
    const navigate = useNavigate();
    const [isNitroClawEnabled] = useAccountFeature(AccountFeature.NitroClaw);
    const [mode, setMode] = useLocalStorage(APP_SHELL_MODE_STORAGE_KEY, DEFAULT_APP_SHELL_MODE);
    useEffect(()=>{
        if (!isTauriApp() && !isNitroClawEnabled && mode === 'nitro-claw') {
            setMode(DEFAULT_APP_SHELL_MODE);
        }
    }, [
        isNitroClawEnabled,
        mode,
        setMode
    ]);
    const isNitroClawShellActive = isNitroClawEnabled && (isTauriApp() || mode === 'nitro-claw');
    /** Hard-cut between shells: set preference and land on that shell's home. */ const switchToAppShell = useCallback((next)=>{
        if (next === mode) {
            return;
        }
        setMode(next);
        navigate({
            pathname: next === 'nitro-claw' ? `/${ROUTE_PATHS.NITRO_CLAW}` : ROUTE_PATHS.ROOT,
            search: '',
            hash: ''
        });
    }, [
        mode,
        navigate,
        setMode
    ]);
    return {
        mode,
        setMode,
        switchToAppShell,
        isNitroClawShellActive,
        isNitroClawEnabled
    };
};
